import React from "react";

export default function Card(props) {
    return(
        <div className={ props.className }>
            { props.src && <img src={ props.src } alt="icon" /> }
            { props.title && <h3>{props.title}</h3> }
            { props.text && <p>{ props.text }</p> }
        </div>
    )
}